import type { SVGAttributes } from 'react';

export type SvgElementProps = SVGAttributes<SVGSVGElement>;
export type PathElementProps = SVGAttributes<SVGPathElement>;
export type CircleElementProps = SVGAttributes<SVGCircleElement>;
export type RectElementProps = SVGAttributes<SVGRectElement>;
export type GElementProps = SVGAttributes<SVGGElement>;
export type TextElementProps = SVGAttributes<SVGTextElement>;
export type ImageElementProps = SVGAttributes<SVGImageElement>;

export function Svg(props: SvgElementProps) {
  return <svg {...props} />;
}

export function Path(props: PathElementProps) {
  return <path {...props} />;
}

export function Circle(props: CircleElementProps) {
  return <circle {...props} />;
}

export function Rect(props: RectElementProps) {
  return <rect {...props} />;
}

export function G(props: GElementProps) {
  return <g {...props} />;
}

/** SVG `<text>` — react-native-svg's `Text` on native (a raw `<text>` crashes RN). */
export function SvgText(props: TextElementProps) {
  return <text {...props} />;
}

/** A real raster image inside an SVG; Image from react-native-svg on native. */
export function SvgImage(props: ImageElementProps) {
  return <image {...props} />;
}
